module.exports = __webpack_public_path__ + "img/05_uk.e3076b45.svg";